module.exports = __webpack_public_path__ + "img/market-activity-09.c9f7b9ef.jpg";